import React from 'react';

const DashboardSummary = () => {
    return (
        <div className="space-y-4">
            <div className="bg-gray-700 p-4 rounded-lg">
                <h5 className="text-blue-300 font-semibold mb-2">Progress Overview</h5>
                <div className="text-gray-300">
                    <p>🎯 Current Lab: OpenShift EX280</p>
                    <p>📊 Progress: In Progress</p>
                    <p>⏱️ Time Spent: Active Session</p>
                </div>
            </div>

            <div className="bg-gray-700 p-4 rounded-lg">
                <h5 className="text-green-300 font-semibold mb-2">Achievements</h5>
                <div className="text-gray-300">
                    <p>✨ Lab Session Started</p>
                    <p>🚀 Components Loaded</p>
                </div>
            </div>

            <div className="bg-gray-700 p-4 rounded-lg">
                <h5 className="text-purple-300 font-semibold mb-2">Quick Stats</h5>
                <div className="text-gray-300 text-sm">
                    <p>System: Ready</p>
                    <p>Status: Active</p>
                </div>
            </div>
        </div>
    );
};

export default DashboardSummary;
